import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Paper,
  Stepper,
  Step,
  StepLabel,
  Typography,
  CircularProgress,
  Divider,
  Button,
} from "@material-ui/core";

import { commerce } from "../../../lib/commerce";

import useStyles from "./styles";
import AddressForm from "../AddressForm";
import PaymentForm from "../PaymentForm";

const steps = ["Shipping Address", "Payment details"];

const Checkout = ({ cart, order, onCaptureCheckout, error, clearOrder }) => {
  const classes = useStyles();

  const [activeStep, setActiveStep] = useState(0);
  const [checkoutTokenId, setCheckoutTokenId] = useState(null);
  const [shippingData, setShippingData] = useState({});

  useEffect(() => {
    const generateToken = async () => {
      try {
        const token = await commerce.checkout.generateToken(cart.id, {
          type: "cart",
        });
        setCheckoutTokenId(token.id);
      } catch (error) {
        // console.log(error);
      }
    };
    generateToken();
  }, [cart]); // cart dependency: generate new token as long as cart changed

  const nextStep = () => {
    setActiveStep((previousActiveStep) => previousActiveStep + 1);
  };
  const backStep = () => {
    setActiveStep((previousActiveStep) => previousActiveStep - 1);
  };

  const startOver = () => {
    setActiveStep((prev) => 0);
  };

  const next = (data) => {
    setShippingData(data);
    nextStep();
  };

  let Confirmation = () =>
    order.customer ? (
      <>
        <div>
          <Typography variant="h5">
            Thank you for your purchase, {order.customer.firstname}
          </Typography>
          <Divider className={classes.divider} />
          <Typography variant="subtitle2">
            Order ref: {order.customer_reference}
          </Typography>
        </div>
        <br />
        <Button
          component={Link}
          to="/"
          variant="outlined"
          type="button"
          onClick={clearOrder}
        >
          Back to Home
        </Button>
      </>
    ) : (
      <div className={classes.spinner}>
        <CircularProgress />
      </div>
    );

  if (error) {
    Confirmation = () => (
      <>
        <Typography variant="h5"> Error: {error} </Typography>
        <br />
        <Button variant="outlined" type="button" onClick={startOver}>
          Back
        </Button>
      </>
    );
  }

  const Form = () =>
    activeStep === 0 ? (
      <AddressForm checkoutTokenId={checkoutTokenId} next={next} />
    ) : (
      <PaymentForm
        shippingData={shippingData}
        checkoutTokenId={checkoutTokenId}
        backStep={backStep}
        onCaptureCheckout={onCaptureCheckout}
        nextStep={nextStep}
      />
    );

  return (
    <>
      <div className={classes.toolbar} />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <Typography variant="h4" align="center">
            Checkout
          </Typography>
          <Stepper activeStep={activeStep} className={classes.stepper}>
            {steps.map((step) => (
              <Step key={step}>
                <StepLabel>{step}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length ? (
            <Confirmation />
          ) : (
            checkoutTokenId && <Form />
          )}
        </Paper>
      </main>
    </>
  );
};

export default Checkout;
